import angular from 'angular';
import allocatedAdviserTooltip from './allocatedAdviserTooltip';

export default angular
  .module('components.allocatedAdviserTooltip', [])
  .component('allocatedAdviserTooltip', allocatedAdviserTooltip).name;
